import {inject} from '@angular/core';
import {patchState, signalStoreFeature, withHooks, withMethods, withState} from '@ngrx/signals';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {filter, map} from 'rxjs';

export interface UiState {
  backButton: boolean;
  backRoute: string | null;
  isHeaderVisible: boolean;
  headerTitle: string;
}

const initialUiState: UiState = {
  backButton: false,
  backRoute: null,
  isHeaderVisible: true,
  headerTitle: '',
};

export function withUiFeature() {
  return signalStoreFeature(
    withState<UiState>(initialUiState),
    withMethods((store) => ({
      setBackRoute: (route: string | null) => {
        patchState(store, {backRoute: route});
      },
      setHeaderTitle: (title: string) => {
        patchState(store, {headerTitle: title});
      },
      setHeaderVisibility: (visible: boolean) => {
        patchState(store, {isHeaderVisible: visible});
      },
      toggleBackButton: (enable: boolean) => {
        patchState(store, {backButton: enable});
      },
    })),

    withHooks({
      onInit(store, router = inject(Router), activatedRoute = inject(ActivatedRoute)) {

        router.events.pipe(
          filter(event => event instanceof NavigationEnd),
          map(() => {

            let route = activatedRoute;
            while (route.firstChild) {
              route = route.firstChild;
            }
            return route.snapshot.data;
          })
        ).subscribe((data) => {

          if (data['title']) {
            patchState(store, {headerTitle: data['title']});
          }


          const isVisible = data['headerVisible'] !== false;
          patchState(store, {isHeaderVisible: isVisible});

          // 3. Botón de volver
          const showBack = !!data['backButton'];
          patchState(store, {backButton: showBack});

          // Resetear backRoute por defecto al navegar (opcional)
          patchState(store, {backRoute: null});
        });
      }
    })
  );
}
